export enum CaroNotificationType {
    accountNotActivated = 'accountNotActivated',
    bodyWeightMeasurementsInactive = 'bodyWeightMeasurementsInactive',
    questionnaireResponsesInactive = 'questionnaireResponsesInactive',
}
